module.exports = __webpack_public_path__ + "media/home-decor.24346fd8.mp4";